/**
 * ライセンスキー正規化（サーバー productLicenseKeysHelper と同ルール）
 */

export const MAX_LICENSE_KEYS_PER_PRODUCT = 3;

export function normalizeLicenseKey(value) {
  if (!value || typeof value !== 'string') return '';
  return value.trim().toLowerCase().replace(/\s+/g, '');
}

export function toLicenseName(productName) {
  if (!productName || typeof productName !== 'string') return '';
  return productName.toLowerCase().replace(/\s+/g, '');
}

export function resolveProductLicenseKeys(product) {
  if (!product) return [];
  if (Array.isArray(product.licenseKeys) && product.licenseKeys.length > 0) {
    return product.licenseKeys.map(normalizeLicenseKey).filter(Boolean);
  }
  const legacy = product.licenseName || (product.name ? toLicenseName(product.name) : '');
  return legacy ? [normalizeLicenseKey(legacy)] : [];
}

export function parseLicenseKeysFromInputs(inputs) {
  const keys = [];
  for (const item of inputs) {
    const normalized = normalizeLicenseKey(item);
    if (!normalized) continue;
    if (keys.includes(normalized)) continue;
    keys.push(normalized);
    if (keys.length >= MAX_LICENSE_KEYS_PER_PRODUCT) break;
  }
  return keys;
}

export function buildSelectableRegistryKeys(registeredKeys, currentKeys) {
  const current = new Set((currentKeys || []).map(normalizeLicenseKey).filter(Boolean));
  return (registeredKeys || [])
    .filter((k) => !current.has(k))
    .sort();
}

/**
 * 製品の1スロット用に選べるレジストリキー（現在値 + 同一製品の他スロット未使用の登録済みキー）
 * 他製品とのキー重複は許可（バンドル共有キー）
 */
export function buildSelectableKeysForProductSlot(registeredKeys, productKeys, currentKey) {
  const current = normalizeLicenseKey(currentKey);
  const onProductOthers = new Set(
    (productKeys || []).map(normalizeLicenseKey).filter((k) => k && k !== current)
  );

  return (registeredKeys || [])
    .filter((k) => k === current || !onProductOthers.has(k))
    .sort();
}

export function licenseKeyInputsFromProduct(product) {
  const keys = resolveProductLicenseKeys(product);
  const inputs = keys.slice(0, MAX_LICENSE_KEYS_PER_PRODUCT);
  while (inputs.length < MAX_LICENSE_KEYS_PER_PRODUCT) {
    inputs.push('');
  }
  return inputs;
}
